import { render, staticRenderFns } from "./Naideno.vue?vue&type=template&id=d2019b6c&"
import script from "./Naideno.vue?vue&type=script&setup=true&lang=js&"
export * from "./Naideno.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Naideno.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports